import { HttpClient } from '@wix/sdk-types';
import {
  EmbeddableItem,
  ItemTypeWithLiterals,
  ListEmbeddableItemsOptions,
  ListEmbeddableItemsResponse,
  getEmbeddableItem as universalGetEmbeddableItem,
  listEmbeddableItems as universalListEmbeddableItems,
} from './ricos-v1-embeddable-item-ricos-embeddables.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/rich-content' };

export function getEmbeddableItem(
  httpClient: HttpClient
): GetEmbeddableItemSignature {
  return (embeddableItemId: string, itemType: ItemTypeWithLiterals) =>
    universalGetEmbeddableItem(
      embeddableItemId,
      itemType,
      // @ts-ignore
      { httpClient }
    );
}

interface GetEmbeddableItemSignature {
  /**
   * Retrieves a specific embeddable item by ID and type.
   * @param - ID of the embeddable item to retrieve.
   * @param - Type of embeddable item to retrieve.
   * @returns Retrieved embeddable item.
   */
  (
    embeddableItemId: string,
    itemType: ItemTypeWithLiterals
  ): Promise<EmbeddableItem>;
}

export function listEmbeddableItems(
  httpClient: HttpClient
): ListEmbeddableItemsSignature {
  return (
    itemType: ItemTypeWithLiterals,
    options?: ListEmbeddableItemsOptions
  ) =>
    universalListEmbeddableItems(
      itemType,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListEmbeddableItemsSignature {
  /**
   * Lists embeddable items by type with optional search and pagination.
   * @param - Type of embeddable items to list.
   * @returns Response message containing app embedded content items
   * Response containing a list of embeddable items.
   */
  (
    itemType: ItemTypeWithLiterals,
    options?: ListEmbeddableItemsOptions
  ): Promise<ListEmbeddableItemsResponse>;
}

export {
  BookingDetails,
  CursorPaging,
  Cursors,
  EmbeddableItem,
  EmbeddableItemItemTypeDetailsOneOf,
  EventDetails,
  GetEmbeddableItemRequest,
  GetEmbeddableItemResponse,
  ItemType,
  ListEmbeddableItemsOptions,
  ListEmbeddableItemsRequest,
  ListEmbeddableItemsResponse,
  PagingMetadataV2,
  PricingData,
} from './ricos-v1-embeddable-item-ricos-embeddables.universal.js';
